var map = {
	"./additionalInfoIcon.svg": 683,
	"./arrowBottomIconSharpSmall.svg": 684,
	"./arrowLeftIcon.svg": 685,
	"./arrowMediumTop.svg": 686,
	"./arrowRightIcon.svg": 687,
	"./arrowRightIconSharp.svg": 688,
	"./arrowRightSmallIcon.svg": 689,
	"./arrowScalableIcon.svg": 690,
	"./arrowSelect2.svg": 691,
	"./arrowSelectIcon.svg": 692,
	"./benefit1.svg": 693,
	"./benefit2.svg": 694,
	"./benefit3.svg": 695,
	"./cardsIcon.svg": 696,
	"./circleInfoIcon.svg": 697,
	"./copyIcon copy.svg": 698,
	"./copyIcon.svg": 699,
	"./crossIcon.svg": 700,
	"./crossIcon2.svg": 701,
	"./crossIcon3.svg": 702,
	"./crossIconSmall.svg": 703,
	"./crossSmallIcon.svg": 704,
	"./defaultCategoryIcon.svg": 705,
	"./depNumberIcon.svg": 706,
	"./elfCentralIcon.svg": 707,
	"./equalitySign.svg": 708,
	"./errorIcon.svg": 709,
	"./eyeClosedIcon.svg": 710,
	"./eyeOpenIcon.svg": 711,
	"./favoritesIcon.svg": 712,
	"./favoritesLabelIcon.svg": 713,
	"./filterDivider.svg": 714,
	"./filterIcon.svg": 715,
	"./frequencyIcon.svg": 716,
	"./fsAmountIcon.svg": 717,
	"./fullScreenIcon.svg": 718,
	"./gameIcon.svg": 719,
	"./gemIcon.svg": 720,
	"./goldGiftIcon.svg": 721,
	"./hamburgerIcon.svg": 722,
	"./infoIcon.svg": 723,
	"./infoIconSmall.svg": 724,
	"./infoSymbol.svg": 725,
	"./levelBackground.svg": 726,
	"./levelBackgroundNew.svg": 727,
	"./linkIcon.svg": 728,
	"./lockIcon.svg": 729,
	"./lockSharpIcon.svg": 730,
	"./maxBonusAmountIcon.svg": 731,
	"./maxWinFsIcon.svg": 732,
	"./menu/fortuneIcon.svg": 456,
	"./menu/fortuneIconL.svg": 457,
	"./menu/helpdeskIcon.svg": 458,
	"./menu/helpdeskIconL.svg": 459,
	"./menu/homeIcon.svg": 460,
	"./menu/homeIconLarge.svg": 461,
	"./menu/jackpotIcon.svg": 462,
	"./menu/logo.svg": 463,
	"./menu/logoSmall.svg": 464,
	"./menu/lotteryIcon.svg": 465,
	"./menu/loyaltyIcon.svg": 466,
	"./menu/mobileAppIcon.svg": 467,
	"./menu/profileIcon.svg": 468,
	"./menu/questIcon.svg": 469,
	"./menu/questsIcon.svg": 470,
	"./menu/rewardLineupIcon.svg": 471,
	"./menu/searchIcon.svg": 472,
	"./menu/searchIconLarge.svg": 473,
	"./menu/signOutIcon.svg": 474,
	"./menu/star.svg": 475,
	"./menu/tournamentIcon.svg": 476,
	"./menu/tournamentLargeIcon.svg": 477,
	"./menu/vipIcon.svg": 478,
	"./menu/wheelIcon.svg": 479,
	"./menu/wheelIconL.svg": 480,
	"./menu/wheelIconMobile.svg": 481,
	"./menuIcon.svg": 733,
	"./minDepIcon.svg": 734,
	"./minusIcon.svg": 735,
	"./noTournamentIcon.svg": 736,
	"./numbers/number-1.svg": 482,
	"./numbers/number-2.svg": 483,
	"./numbers/number-3.svg": 484,
	"./numbers/number-4.svg": 485,
	"./numbers/number-5.svg": 486,
	"./numbers/number-6.svg": 487,
	"./numbers/number-7.svg": 488,
	"./numbers/number-8.svg": 489,
	"./numbers/number-9.svg": 490,
	"./numbers/number-shine-1.svg": 491,
	"./numbers/number-shine-2.svg": 492,
	"./numbers/number-shine-3.svg": 493,
	"./numbers/number-shine-4.svg": 494,
	"./numbers/number-shine-5.svg": 495,
	"./numbers/number-shine-6.svg": 496,
	"./numbers/number-shine-7.svg": 497,
	"./numbers/number-shine-8.svg": 498,
	"./numbers/number-shine-9.svg": 499,
	"./playIcon.svg": 737,
	"./plusIcon.svg": 738,
	"./polygon.svg": 739,
	"./preloaderDotsAnimation.svg": 740,
	"./preloaderSpinnerAnimation.svg": 741,
	"./present2Icon.svg": 742,
	"./presentIcon.svg": 743,
	"./promoIcon.svg": 744,
	"./recentIcon.svg": 745,
	"./search2Icon.svg": 746,
	"./search3Icon.svg": 747,
	"./sharpTickIcon copy.svg": 748,
	"./sharpTickIcon.svg": 749,
	"./smallInfoSymbol.svg": 750,
	"./smoothArrowIcon.svg": 751,
	"./successIcon.svg": 752,
	"./supportIcon.svg": 753,
	"./tag1Icon.svg": 754,
	"./tag2Icon.svg": 755,
	"./tag3Icon.svg": 756,
	"./tag4Icon.svg": 757,
	"./tickIcon.svg": 758,
	"./unverified.svg": 759,
	"./verified.svg": 760,
	"./wagerIcon.svg": 761,
	"./wagerTimeIcon.svg": 762,
	"./warningIcon.svg": 763,
	"./zoomIcon.svg": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 682;